import _ from 'lodash';

export function careCoordinatorFilterDefault(userId, isCaseManager) {
  return isCaseManager ? [userId] : [];
}

export function noneAssignedOption(state) {
  return {
    label: 'None Assigned',
    value: 'none',
    initial: _.includes(state, 'none'),
  };
}

export const BLANK_PROGRAM_VALUE = 'blank';

export function blankProgramOption(state) {
  return {
    label: '(Blanks)',
    value: BLANK_PROGRAM_VALUE,
    initial: _.includes(state, BLANK_PROGRAM_VALUE),
  };
}

// Pins "(Blanks)" above the program options. While searching it only stays when it matches the query.
export function withBlankProgramOption(programOptions, { enabled, selected, query } = {}) {
  if (!enabled) {
    return programOptions;
  }
  const blankOption = blankProgramOption(selected);
  const matchesQuery = !query || _.includes(_.toLower(blankOption.label), _.toLower(_.trim(query)));
  return matchesQuery ? [blankOption, ...programOptions] : programOptions;
}

function validCaseLicenses(licensing, isCC) {
  const filteredLicenses = _.compact(_.map(licensing, 'subscription_type'));
  if (isCC) {
    return _.includes(filteredLicenses, 'network');
  }
  return _.includes(filteredLicenses, 'network') && _.includes(filteredLicenses, 'group');
}

export const NETWORK_SCOPE_OPTIONS = [
  { label: 'Network Scope (All)', value: 'all' },
  { label: 'In Network', value: 'in' },
  { label: 'Out of Network', value: 'out' },
];

export const CASE_TYPE_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Network Cases', value: 'network' },
  { label: 'Organization Cases', value: 'group' },
];

export function returnScopeFilter(licensing, isCC, options) {
  if (validCaseLicenses(licensing, isCC)) {
    return options;
  }

  return null;
}

export function networkGroupsOptions(networkGroups, activeFilters) {
  return _.reduce(networkGroups, (a, curr) => (
    _.reduce(curr, (acc, c) => (
      _.concat(acc, {
        label: c.name,
        value: c.id,
        initial: _.includes(activeFilters, c.id),
      })
    ), a)
  ), []);
}
